import { Component, DestroyRef, inject, input, output, signal } from "@angular/core";
import { IconFeature } from "src/app/shared/contract/Module/DataMode";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";
import { TaskIconComponent } from "../task-icon/task-icon.component";
import { TranslocoPipe } from "@jsverse/transloco";
import { PermissionService } from "../../core/services/permission.service";

@Component({
  selector: "app-spatial-analysis-task-bar",
  templateUrl: "./spatial-analysis-task-bar.component.html",
  styleUrls: ["./spatial-analysis-task-bar.component.scss"],
  imports: [MatTooltip, MatIcon, TaskIconComponent, TranslocoPipe]
})
export class SpatialAnalysisTaskBarComponent {
  permissionService = inject(PermissionService);
  destroyRef = inject(DestroyRef);

  modes = input<IconFeature[]>();
  taskIconClicked = output<IconFeature>();

  showMenu = signal(false);

  openMenu() {
    this.showMenu.set(true);
  }

  closeMenu() {
    this.showMenu.set(false);
  }

  triggerTaskIconClick(feature: IconFeature) {
    this.closeMenu();
    this.taskIconClicked.emit(feature);
  }
}
